<template>
  <!-- A channel name in its rank colour; a click filters the page to it (the parent decides) -->
  <button
    type="button"
    class="btn btn-sm channel-pill"
    :style="pillStyle"
    :title="`Show only calls from ${channel}`"
    @click="$emit('click', channel)"
  >
    <strong>{{ channel }}</strong>
  </button>
</template>

<script>
import { channelPillStyle } from '@/utils/channelColors'

export default {
  name: 'ChannelPill',

  props: {
    channel: {
      type: String,
      required: true
    },

    // From rankChannelColors; grey when left out
    color: {
      type: String,
      default: ''
    }
  },

  computed: {
    pillStyle() {
      return channelPillStyle(this.color)
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-pill {
  border: 1px solid;
  line-height: 1.4;

  &:hover,
  &:focus {
    filter: brightness(1.2);
  }
}
</style>
